import {FormField, type FormControl} from 'platform/components';

import type {PricelistVersionValues} from '../schemas/pricelistVersionSchema';
import {t} from '../utils/catalogueUi';

/** The label and note of a new pricelist version, shared by the adjustment and the item change confirm. */
export function PricelistVersionFields(props: {
  control: FormControl<PricelistVersionValues>;
  currentLabel: string;
  onLabelChange?: (label: string | null) => void;
}) {
  return (
    <>
      <FormField
        control={props.control}
        name="nextVersion"
        type="text"
        isRequired
        onChange={props.onLabelChange}
        label={t('entity.newVehicle.catalogue.nextPricelistVersion', 'Next pricelist version')}
        helperText={t(
          'entity.newVehicle.catalogue.adjustment.versionHelp',
          'Currently {label}. Must be a label this model year has not used before.',
          {label: props.currentLabel}
        )}
      />
      <FormField
        control={props.control}
        name="note"
        type="text"
        label={t('general.labels.note', 'Note')}
        placeholder={t(
          'entity.newVehicle.catalogue.adjustment.notePlaceholder',
          'e.g. Importer price increase Q3'
        )}
      />
    </>
  );
}
